import { Facets } from '~/features/facets/components/Facets';
import { FacetSelection } from '~/features/facets/components/FacetSelection';
import { FacetsOverlay } from '~/features/facets/components/FacetsOverlay/FacetsOverlay';
import { AnimatedAutoHeight } from '~/shared/components/AnimatedAutoHeight/AnimatedAutoHeight';
import { FilterHeaderProps } from '../models/M170ProductFilter';
import { SelectedFacetsTagList } from './SelectedFacetsTagList';
import { SortingButton } from './SortingButton';
import { SortingSelection } from './SortingSelection';
import {
	StyledFacetAndSortingOptions,
	StyledFacetAndSortingOptionsWrapper,
	StyledFacetsAndSortingWrapper,
	StyledFacetsList,
	StyledFilterHeaderWrapper,
	StyledQuantity,
} from './styled';

const FilterHeader = ({ filterData, filterExpandState, selectableFacetValues, showSelectedFacets, showFacetsList, productsCount, translate }: FilterHeaderProps) => {
	const { facets, sorting, selectedFacets, updateSort, toggleFacetValue, removeAllFacets, updateFilterUrl } = filterData;
	const { expandedOption, expandedOptionId, toggleExpandedFacet, toggleExpandedSorting } = filterExpandState;

	const hasSorting = sorting.options.length > 0;

	return (
		<StyledFilterHeaderWrapper>
			<StyledFacetsAndSortingWrapper hasSorting={hasSorting}>
				{showFacetsList ? (
					<StyledFacetsList>
						<Facets
							facets={facets}
							expandedFacetId={expandedOptionId}
							onFacetSelected={toggleExpandedFacet}
						/>
					</StyledFacetsList>
				) : null}

				<FacetsOverlay
					selectedFacetsCount={selectedFacets.length}
					showOnDesktop={!showFacetsList}
					form={{
						facets: facets,
						onFacetValueToggle: toggleFacetValue,
						onFacetsClear: removeAllFacets,
						onSubmit: updateFilterUrl,
					}}
				/>

				<StyledQuantity>{translate('filter.product-amount', { quantity: productsCount })}</StyledQuantity>

				{hasSorting ? (
					<SortingButton
						sorting={sorting}
						onToggle={() => toggleExpandedSorting()}
						onChange={updateSort}
					/>
				) : null}
			</StyledFacetsAndSortingWrapper>

			<StyledFacetAndSortingOptionsWrapper
				id={`facet_${expandedOptionId}` ?? undefined}
				role="region"
				aria-live="polite"
				aria-label="show list of available facets"
				aria-labelledby={`tab_${expandedOptionId}` ?? undefined}
			>
				<AnimatedAutoHeight>
					{expandedOption === 'facet' && expandedOptionId && (
						<StyledFacetAndSortingOptions>
							<FacetSelection
								onFacetValueSelected={(id) => toggleFacetValue(expandedOptionId, id, true)}
								facetValues={selectableFacetValues}
							/>
						</StyledFacetAndSortingOptions>
					)}

					{expandedOption === 'sorting' && (
						<StyledFacetAndSortingOptions>
							<SortingSelection
								onSelected={(id) => updateSort(id, true, true)}
								sorting={sorting}
							/>
						</StyledFacetAndSortingOptions>
					)}
				</AnimatedAutoHeight>
			</StyledFacetAndSortingOptionsWrapper>

			{showSelectedFacets ? (
				<SelectedFacetsTagList
					onFacetClick={toggleFacetValue}
					onRemoveAllClick={() => removeAllFacets(true)}
					facetValues={selectedFacets}
				/>
			) : null}
		</StyledFilterHeaderWrapper>
	);
};

export default FilterHeader;
